import { LeftOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import "./RegStepPayment.scss";
import { paymentJsLoadedState, planLengthState, planTypeState } from "../../state/atoms";
import DashboardApi from "../../api/DashboardApi";
import { Spinner } from "../account/misc/Spinner";
import { useRecoilValue } from "recoil";
import StepCounter from "../StepCounter";

interface RegStepPaymentProps {
  onNext: () => void;
  onBack?: () => void;
  regStep: number;
  regStepTotal: number;
}

export default function RegStepPayment({ onNext, onBack, regStep, regStepTotal }: RegStepPaymentProps) {
  const divRef = useRef<HTMLDivElement>(null);
  const paymentJsLoaded = useRecoilValue(paymentJsLoadedState);
  const planType = useRecoilValue(planTypeState);
  const planLength = useRecoilValue(planLengthState);
  const [memberId, setMemberId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    DashboardApi.status().then((resp) => {
      const {member} = resp.data;
      setMemberId(member?.id ?? '');
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!divRef.current || !paymentJsLoaded || !memberId || !planType) return;

    window.MHM.ProModal.upgradeInline({
      memberId: memberId,
      onSuccess: onNext,
      container: divRef.current,
      planType: planType,
      planLength: planLength
    });

    return () => {
      window.MHM.ProModal.destroy();
    }
  }, [divRef, paymentJsLoaded, onNext, planType, planLength, memberId]);
  return loading ? <div className={'spinner'}><Spinner/></div> : <div className={"step-type step full payment standalone-payment-wrapper"}>
    {onBack && <div className={"back"} onClick={onBack}><LeftOutlined /></div>}
    <StepCounter total={regStepTotal} current={regStep}/>
    <div ref={divRef}></div>
  </div>;
}
